import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button, Input, Modal} from "antd"
import SelectPartnerSewing from "./SelectPartnerSewing"

class PopupConfirm extends Component {
    _handleChangeInput = (e) => {
        const {name, value} = e.target
        const {onChangeInput} = this.props

        if (typeof onChangeInput === 'function') {
            if(name==='material_weight'){
                onChangeInput(name, parseFloat(value))
            }
            onChangeInput(name, value)
        }
    }

    render() {
        const {
            visible,
            onUpdate,
            onClose,
            message,
            status,
            loading,
            item,
            total,
            partner,
            giveSewName,
            material_weight,
            batch,
            onChangeSelect,
        } = this.props
        const partnerCheck = !!batch && !!batch.partner && batch.partner.name
        const disableBtn1 = status === 'sewing' && (partner === '' || (giveSewName === '' || giveSewName.trim() === ''))
        // const disableBtn2 = status === 'wait_to_sew' && partnerCheck ==='QUANG MINH' && !material_weight

        return (
            <Modal
                title="Thay đổi trạng thái lô"
                className={'CustomModal'}
                visible={visible}
                width={950}
                onCancel={onClose}
                footer={[
                    <div className='d-flex justify-content-between align-content-center' key='confirm'>
                        <Button key="back" size='large' onClick={onClose}>
                            Hủy
                        </Button>
                        <Button
                            key="submit"
                            type="primary"
                            size='large'
                            loading={loading}
                            onClick={onUpdate}
                            disabled={disableBtn1}
                        >
                            Thay đổi
                        </Button>
                    </div>
                ]}
            >
                {
                    status === 'sewing' &&
                    <div className='d-flex align-items-center justify-content-between'>
                        <SelectPartnerSewing partner={partner} onChangePartner={onChangeSelect} />

                        <div className='Human mb-3'>
                            <label className='d-block'>Người giao may (<span className='text-danger'>* bắt buộc</span>)</label>
                            <Input
                                value={giveSewName}
                                size='large'
                                name='giveSewName'
                                placeholder={'Người giao may'}
                                onChange={this._handleChangeInput}
                            />
                        </div>

                    </div>
                }
                {/* {status === 'wait_to_sew' && partnerCheck === 'QUANG MINH' &&
                    <div className='d-flex align-items-center justify-content-between'>
                        <div className='Human mb-3'>
                            <label className='d-block'>Kg vải thực tế (<span className='text-danger'>* bắt buộc</span>)</label>
                            <Input
                                value={material_weight}
                                size='large'
                                name='material_weight'
                                placeholder={'Kg vải thực tế'}
                                onChange={this._handleChangeInput}
                                allowClear
                                type='Number'
                            />
                        </div>
                    </div>
                } */}

                <p className='message-popup mt-3'>Bạn sẽ thay đổi
                    <span className='font-weight-bold ml-2 Item'>{item}</span>/<span
                        className='font-weight-bold mr-2'>{total}</span>
                    {item > 1 ? 'items' : 'item'} của lô sang
                    <span className='font-weight-bold ml-2'>{message}({status})</span>?
                </p>
            </Modal>
        )
    }
}

PopupConfirm.propTypes = {
    loading: PropTypes.bool.isRequired,
    visible: PropTypes.bool.isRequired,
    onUpdate: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    status: PropTypes.string,
    message: PropTypes.string.isRequired,
    item: PropTypes.number,
    total: PropTypes.number,
    partner: PropTypes.string,
    giveSewName: PropTypes.string,
    onChangeSelect: PropTypes.func.isRequired,
    onChangeInput: PropTypes.func.isRequired
}

export default PopupConfirm
